import React from 'react'
import styled from 'styled-components'

interface IProps {
  children: JSX.Element
}

export default function Main({ children }: IProps) {
  return <Container>{children}</Container>
}

const Container = styled.main`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: calc(100% - 48px);
  justify-content: flex-start;
  width: 100%;
`
